<template>
  <div class="v10-style-bottom" :class="{ mobile: isMobile ? true : false }" @click="handleClick">
    <img class="bottom-bg" src="@/assets/img/style10/bottom_bg.png" v-if="!isMobile" />
    <div class="button-left">
      <div
        class="info-item3"
        :style="getHeaderInfopStyle()"
        v-if="icon1?.iconUrl"
        @click.stop="handleJump(icon1?.url)"
      >
        <el-tooltip :content="headerIcon1Name" placement="top">
          <img :src="icon1.iconUrl" alt="" />
        </el-tooltip>
      </div>
      <!-- <div> -->
      <div class="info-item" @click="toggleChartShow">
        <p :style="getHeaderInfopStyle()">
          <el-tooltip :content="!isHideAllCharts ? '隐藏全部图表' : '显示全部图表'" placement="bottom">
            <i :class="!isHideAllCharts ? 'iconfont icon-huabankaobei-' : 'iconfont icon-yanjing-guan'"></i>
          </el-tooltip>
        </p>
      </div>
      <!-- </div> -->
    </div>
    <div
      class="menu-box"
      v-if="!isMobile"
      :style="{
        height: $h_Ratio(menuStyle.height, $store) + 'px',
        minWidth: $w_Ratio(menuStyle.width, $store) + 'px',
      }"
      :class="{ 'menu-down': !isOpenBottomMenu }"
    >
      <div
        class="menu-list"
        :style="{
          top: $h_Ratio(-97, $store) + '%',
        }"
      >
        <div
          class="menu-item"
          :class="{ itemActive: item.id === $store.state.ProjectInfo.CurrentScene.id }"
          :style="getMenuItemStyle()"
          @click="handleSwitchScene(item)"
          v-for="item in $store.state.ProjectInfo.SceneryList"
          :key="item.id"
          :id="item.id"
        >
          <div
            class="menu-item-icon-ct"
            :class="{ active: item.id === $store.state.ProjectInfo.CurrentScene.id }"
          >
            <img :src="item.IconPath" alt="" class="img" />
          </div>
          <div
            class="menu-item-icon-name"
            :style="{
              transform: `scale(${$w_Ratio(1, $store)})`,
            }"
            :class="{ activeName: item.id === $store.state.ProjectInfo.CurrentScene.id }"
          >
            {{ item.SceneName }}
          </div>
        </div>
      </div>
    </div>
    <div class="button-right" v-if="!isMobile">
      <div>
        <div class="info-item3">
          <div
            class="icon icon2"
            :style="getHeaderInfopStyle()"
            v-if="icon2?.iconUrl"
            @click.stop="handleJump(icon2?.url)"
          >
            <el-tooltip :content="headerIcon2Name" placement="top">
              <img :src="icon2.iconUrl" alt="" />
            </el-tooltip>
          </div>
          <p :style="getHeaderInfopStyle()">
            <!--<span>控件</span>-->
          </p>
        </div>
      </div>
    </div>
    <div class="toggle-open-btn" v-if="!isMobile" :style="getToggleOpenBtn()" @click="toggleOpen">
      <i :class="isOpenBottomMenu ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>

    <!-- 手机端 -->
    <div class="mobile-menu" v-if="isMobile">
      <div class="icon" @click="isShow = !isShow">
        <img src="@/assets/img/mobile/menu.png" alt="" />
      </div>
      <div
        class="scene"
        :style="{
          left: isShow ? '0%' : '150px',
          height: `${$w_Ratio(1000, $store)}px`,
        }"
      >
        <div
          class="menu-item"
          :style="getMenuMobileItemStyle()"
          @click="handleSwitchScene(item)"
          v-for="item in $store.state.ProjectInfo.SceneryList"
          :key="item.id"
        >
          <div
            class="menu-item-icon-ct"
            :class="{ active: item.id === $store.state.ProjectInfo.CurrentScene.id }"
          >
            <!-- <img
              :src="item.IconActivePath"
              v-if="item.id === $store.state.ProjectInfo.CurrentScene.id"
              alt=""
            /> -->
            <!-- <img src="/img/styles/menusIcons/bottomIcon/V3bottom.png"
                 alt=""
                 class="bk" /> -->

            <img :src="item.IconPath" alt="" class="pic" />
          </div>
          <div
            class="menu-item-icon-name"
            :style="{
              transform: `scale(${$w_Ratio(1, $store)})`,
            }"
          >
            {{ item.SceneName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'V3StyleBottom',
  components: {},
  props: {
    Configuration: Object,
    SceneryList: Array,
  },
  data() {
    return {
      isShow: false,
      isOpenBottomMenu: true,
      stylelabel: {
        // height: 100,
      },
      icon1: { isShowIcon: false, iconUrl: '', url: '' }, // 图标1
      icon2: { isShowIcon: false, iconUrl: '', url: '' }, // 图标2
      // icon3: { isShowIcon: false, iconUrl: '', url: '' }, // 图标3
      headerIcon2Name: '', // 跳转图标2名称
      // headerIcon3Name: '', // 跳转图标3名称
      headerIcon1Name: '', // 跳转图标1名称
      menuStyle: {
        height: 85,
        width: 700,
      },
      menuItemStyle: {},
      backgroundDefault: null, // 临时存储原来背景
    };
  },
  watch: {
    styleIcon1: {
      deep: true,
      handler: function (newVal) {
        this.icon1 = newVal;
      },
    },
    styleIcon2: {
      deep: true,
      handler: function (newVal) {
        this.icon2 = newVal;
      },
    },
    SceneryList: {
      deep: true,
      handler: function (newVal) {
        this.setMenuShowLength(newVal);
      },
    },
  },
  created() {
    this.onConfigurationChange();
    // this.setMenuShowLength(this.SceneryList);
    // if (this.Configuration.propertyData.menuStyle) {
    //   this.menuStyle = this.$_.cloneDeep(this.Configuration.propertyData.menuStyle.value);
    // }
  },
  mounted() {
    console.log(this.styleIcon1, 'dfgdfdfd');

    this.headerIcon2Name = this.Configuration.propertyData?.headerIcon2?.value?.name;
    this.headerIcon1Name = this.Configuration.propertyData?.headerIcon1?.value?.name;
    // this.headerIcon3Name = this.Configuration.propertyData?.headerIcon3?.value?.name;
    this.setMenuShowLength(this.SceneryList);
    if (this.Configuration.propertyData.menuStyle) {
      this.menuStyle = this.$_.cloneDeep(this.Configuration.propertyData.menuStyle.value);
    }
    this.SceneryList.sort((a, b) => {
      return a.sceneSortIndex - b.sceneSortIndex;
    });
    this.backgroundDefault = this.$store.state.ProjectInfo.Background;
  },
  methods: {
    ...mapMutations(['set_CurrentScene', 'set_ProjectBackground', 'set_CurrentConfigration']),
    setMenuShowLength(SceneryList) {
      if (SceneryList.length > 4) {
        this.menuStyle.width = 700 + (SceneryList.length - 4) * 95;
      }
      if (this.Configuration.propertyData.menuStyle) {
        this.$store.commit('set_ProjectStylePropertyData', {
          key: 'menuStyle',
          value: this.$_.cloneDeep(this.menuStyle),
        });
      }
    },
    onConfigurationChange() {
      // this.style.backgroundColor = this.Configuration.propertyData.headerBackgroundColor.value;
      // this.cityName = this.Configuration.propertyData.cityName.value;
      this.icon1 = this.Configuration?.propertyData?.headerIcon1?.value;
      this.icon2 = this.Configuration?.propertyData?.headerIcon2?.value;
      this.icon3 = this.Configuration?.propertyData?.headerIcon3?.value;
      // this.getWeather();
    },
    handleJump(url) {
      if (url) {
        window.open(url);
      } else {
        this.$ElMessage.warning('请配置地址！');
      }
    },
    toggleOpen() {
      this.isOpenBottomMenu = !this.isOpenBottomMenu;
    },
    getHeaderInfopStyle(fs = 14, pt = 15) {
      return {
        paddingTop: this.$h_Ratio(pt, this.$store) + 'px',
        fontSize: this.$w_Ratio(fs, this.$store) + 'px',
      };
    },
    toggleChartShow() {
      if (!this.isHideAllCharts) {
        this.$store.commit('set_chartsShowStatus', {
          id: 'none',
          status: 'hide',
          isAll: true,
        });
      } else {
        this.$store.commit('set_chartsShowStatus', {
          id: 'none',
          status: 'norm',
          isAll: true,
        });
      }
    },
    handleSwitchScene(item) {
      this.set_CurrentScene(item.id);
      this.isShow = false;
      if (item.isChangeBk === true) {
        if (item.Background.componentTitle === '图片背景') {
          let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
          if (
            backgroundDefault == null ||
            backgroundDefault == 'null' ||
            backgroundDefault == undefined ||
            backgroundDefault == 'undefined'
          ) {
            this.set_ProjectBackground(this.backgroundDefault);
            this.set_CurrentConfigration(this.backgroundDefault);
          } else {
            this.set_ProjectBackground(backgroundDefault);
            this.set_CurrentConfigration(backgroundDefault);
          }
        } else {
          this.set_ProjectBackground(item.Background);
          this.set_CurrentConfigration(item.Background);
        }
      } else {
        let backgroundDefault = JSON.parse(localStorage.getItem('backgroundDefault'));
        if (
          backgroundDefault == null ||
          backgroundDefault == 'null' ||
          backgroundDefault == undefined ||
          backgroundDefault == 'undefined'
        ) {
          this.set_ProjectBackground(this.backgroundDefault);
          this.set_CurrentConfigration(this.backgroundDefault);
        } else {
          this.set_ProjectBackground(backgroundDefault);
          this.set_CurrentConfigration(backgroundDefault);
        }
      }
    },
    getMenuStyle() {
      return {
        height: this.$h_Ratio(this.menuStyle.height, this.$store) + 'px',
        minWidth: this.$w_Ratio(this.menuStyle.width, this.$store) + 'px',
      };
    },
    getMenuItemStyle() {
      return {
        height: this.$w_Ratio(80, this.$store) + 'px',
        width: this.$w_Ratio(100, this.$store) + 'px',
        fontSize: '12px',
        margin: `0 ${this.$w_Ratio(4, this.$store)}px`,
      };
    },
    // 移动端按钮样式
    getMenuMobileItemStyle() {
      return {
        height: this.$w_Ratio(110, this.$store) + 'px',
        width: this.$w_Ratio(90, this.$store) + 'px',
        fontSize: this.$w_Ratio(36, this.$store) + 'px',
        margin: `${this.$w_Ratio(7, this.$store)}px 
               ${this.$w_Ratio(10, this.$store)}px`,
      };
    },

    getToggleOpenBtn() {
      return {
        height: this.$h_Ratio(13, this.$store) + 'px',
        width: this.$w_Ratio(150, this.$store) + 'px',
        fontSize: this.$w_Ratio(14, this.$store) + 'px',
      };
    },
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
    },
  },
  computed: {
    ...mapState({
      isHideAllCharts: state => state.ProjectInfo.isHideAllCharts,
      isMobile: state => state.isMobile,
      SceneryList: state => state.ProjectInfo.SceneryList,
      styleIcon1: state => state.styleIcon1,
      styleIcon2: state => state.styleIcon2,
    }),
    newSceneryList() {
      return this.SceneryList.sort((a, b) => {
        return a.sceneSortIndex - b.sceneSortIndex;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.mobile {
  top: 20px;
  right: 0 !important;
  width: 40px !important;
  left: unset !important;
  transform: none !important;
  height: 40px;
}

.v10-style-bottom {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  width: 100%;
  transition: all 0.3s linear;
  color: white;
  z-index: 99;
  height: 10%;
  display: flex;
  justify-content: space-between;
  background-image: linear-gradient(to top, rgba(0, 0, 0, 0.32) 45%, transparent 100%);
  .bottom-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
  }
  .button-left {
    max-width: 400px;
    position: relative;
    width: 10%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
  .button-right {
    max-width: 400px;
    position: relative;
    width: 10%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .info-item3 {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
  }
  .menu-box {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    transition: all 0.3s ease-out;

    .menu-list {
      position: absolute;
      display: flex;
      top: -83%;
      left: 50%;
      transform: translateX(-50%);
      align-items: flex-end;
      justify-content: space-around;
      height: 100%;
      .itemActive {
        background: url('/img/styles/menusIcons/bottomIcon/V10bottomactv.png') !important;
        background-repeat: no-repeat !important;
        background-position-x: center !important;
        background-position-y: center !important;
        background-size: 100% 100% !important;
      }
      .menu-item {
        cursor: pointer;
        flex-shrink: 0;
        transition: all 0.3s ease-out;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        background: url('/img/styles/menusIcons/bottomIcon/V10bottom.png');
        background-repeat: no-repeat;
        background-position-x: center;
        background-position-y: center;
        background-size: 100% 100%;

        .menu-item-icon-name {
          text-align: center;
          white-space: nowrap;
          color: #cedad7;
          font-size: 16px;
          transition: all 0.3s ease-out;
        }

        .menu-item-icon-ct {
          width: 50%;
          transition: all 0.3s ease-out;
          z-index: 999999 !important;
          .bk {
            position: absolute;
            z-index: 1;
            bottom: 0;
            transition: all 0.3s ease-out;
          }

          img.img {
            position: relative;
            z-index: 2;
            width: 62%;
            // height: 70%;
            transition: all 0.3s ease-out;
            margin: 0 auto;
          }

          opacity: 0.8;
        }
        .active {
          opacity: 2 !important;
        }

        .activeName {
          text-shadow: 0 3.84px 0 hsla(0, 0%, 100%, 0.28);
          color: #fff;
          font-size: 17px;
        }
        &:hover .menu-item-icon-name {
          text-shadow: 0 3.84px 0 hsla(0, 0%, 100%, 0.28);
          color: #fff;
          font-size: 17px;
        }

        &:hover .menu-item-icon-ct {
          opacity: 2 !important;
        }
      }
    }
  }

  .menu-down {
    transform: translate(-50%, 200%);
  }

  .toggle-open-btn {
    cursor: pointer;
    width: 150px;
    height: 13px;
    font-size: 14px;
    background-color: #212631;
    border-radius: 20px 20px 0 0;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    font-weight: 700;

    &:hover {
      color: rgb(35, 130, 255);
    }
  }
}

// 手机端
.mobile-menu {
  position: absolute;

  .icon {
    cursor: pointer;
    width: 30px;
  }

  .scene {
    position: absolute;
    left: -50px;
    top: 50px;
    overflow: overlay;
    background: url('../../../assets/img/mobile/style3/menu_item_bk.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    transition: all 0.3s ease-in-out;
    transform: translate(-50%, 0);
    height: 480px;
  }
  /* 滚动条的宽度 */
  :deep() .scene::-webkit-scrollbar {
    /* 横向滚动条 */
    width: 2px;
    /* 纵向滚动条 必写 */
    height: 6px;
  }
  /* 滚动条的滑块 */
  :deep() .scene::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 2px;
  }
  .menu-item {
    cursor: pointer;
    flex-shrink: 0;
    /* background-color: #4a57ce; */
    transition: all 0.3s ease-out;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    .menu-item-icon-name {
      text-align: center;
      white-space: nowrap;
      /* margin-right: 8px; */
    }

    .menu-item-icon-ct {
      width: 70%;
      height: 50%;
      transition: all 0.3s ease-out;
      margin-bottom: 2px;
      position: relative;

      img.bk {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;
        left: 0;
        /* top: 4px;*/
      }

      img.pic {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 2;
        top: 0;
      }

      opacity: 0.8;
    }

    .active {
      width: 90%;
      height: 64%;
      opacity: 1;
    }

    &:hover .menu-item-icon-ct {
      width: 90%;
      height: 64%;
    }
  }
}
</style>
